import React from 'react';
export function TickerBar() {
  const items = ['SOLO POR HOY — 8 CURSOS GRATIS INCLUIDOS', 'ACCESO INMEDIATO TRAS EL PAGO', 'GARANTÍA 30 DÍAS SIN PREGUNTAS', 'PAGO ÚNICO — SIN CUOTAS MENSUALES'];
  // Duplicate items to create a seamless infinite loop
  const tickerItems = [...items, ...items, ...items];
  return <div className="bg-pink overflow-hidden py-2.5 whitespace-nowrap" data-id="element-152">
      <div className="inline-flex animate-ticker" data-id="element-153">
        {tickerItems.map((item, index) => <span key={index} className="font-bebas text-[15px] tracking-[2px] text-white px-8 flex items-center" data-id="element-154">
            <span className="text-gold mr-1.5" data-id="element-155">✦</span> {item}
          </span>)}
      </div>
    </div>;
}